import { render } from "./ServicePage.vue?vue&type=template&id=749da0ce&scoped=true"
import script from "./ServicePage.vue?vue&type=script&lang=js"
export * from "./ServicePage.vue?vue&type=script&lang=js"

import "./ServicePage.vue?vue&type=style&index=0&id=749da0ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-749da0ce"]])

export default __exports__